import React from 'react';
import Typography from '@mui/material/Typography';
import Session from '../shared/Session';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Divider from '@mui/material/Divider';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Tooltip from '@mui/material/Tooltip';

export default class ReportBuilder extends React.Component<any, any> {
    timer = null;

    constructor(props: any) {
        super(props);
        this.state = {
            ssh: []
        };
    };

    render() {
        let sshElements = this.state.ssh.map((ssh: any, index: any) => {
            let id = "ssh-" + index.toString();
            return <>
                <FormControl size="medium" key={index.toString() + "-formcontrol"}>
                    <TextField
                        key={id + "-host"}
                        id={id + "-host"}
                        type="text"
                        label="Host"
                        required={true}
                        defaultValue={ssh.host}
                        variant="standard"
                        size="medium"
                    />
                    <br />
                    <TextField
                        key={id + "-port"}
                        id={id + "-port"}
                        type="number"
                        label="Port"
                        required={true}
                        defaultValue="22"
                        variant="standard"
                        size="medium"
                    />
                    <br />
                    <TextField
                        key={id + "-username"}
                        id={id + "-username"}
                        type="text"
                        label="Username"
                        required={true}
                        defaultValue=""
                        variant="standard"
                        size="medium"
                    />
                    <br />
                    <TextField
                        key={id + "-password"}
                        id={id + "-password"}
                        type="password"
                        label="Password"
                        required={false}
                        defaultValue=""
                        helperText="If a private key is provided, it will be used before the password."
                        variant="standard"
                        size="medium"
                    />
                    <br />
                    <TextField
                        key={id + "-key"}
                        id={id + "-key"}
                        type="text"
                        multiline
                        rows={3}
                        label="Private Key"
                        required={false}
                        defaultValue=""
                        variant="standard"
                    />
                </FormControl>
                <Tooltip key={id + "-remove"} title="Remove">
                    <IconButton key={id + "-removeicon"} size="small" color="inherit" onClick={() => {
                        this.setState({
                            ssh: this.state.ssh.filter((_: any, i: any) => i !== index)
                        });
                    }}>
                        <RemoveIcon key={id + "-remove-icon"} />
                    </IconButton>
                </Tooltip>
                <Divider key={id + "-divider"} sx={{borderBottomWidth: 4}}/>
            </>
        });

        return (
            <>
                <Typography variant="h4" align="left" gutterBottom component="h4">
                    Report Builder
                </Typography>
                <Typography variant="h6" align="left" gutterBottom component="h6">
                    Build your report configuration here. Then you can generate multiple results and view / distrubute them.
                </Typography>
                <Divider sx={{borderBottomWidth: 4}}/>
                <form id="login-form" onSubmit={(e) => {
                    e.preventDefault();
                    this.setState({
                        loadingNewTask: true
                    });

                    let name = (document.getElementById("report-name") as HTMLInputElement).value;
                    let configuration: any = {
                        ssh: []
                    };
                    let sshCount = 0;
                    while (true) {
                        if ( document.getElementById(`ssh-${sshCount}-host`) ) {
                            configuration.ssh.push({
                                "host": (document.getElementById(`ssh-${sshCount}-host`) as HTMLInputElement).value,
                                "port": (document.getElementById(`ssh-${sshCount}-port`) as HTMLInputElement).value,
                                "username": (document.getElementById(`ssh-${sshCount}-username`) as HTMLInputElement).value,
                                "password": (document.getElementById(`ssh-${sshCount}-password`) as HTMLInputElement).value,
                                "private_key": (document.getElementById(`ssh-${sshCount}-key`) as HTMLInputElement).value
                            });
                            sshCount++;
                        } else {
                            break;
                        }
                    }

                    Session.api("POST", "/reports/", {
                        name: name,
                        template: "ssh-report.html",
                        configuration: configuration
                    }, () => {
                        Session.navigate("/data?view=reports");
                        Session.app.setState({
                            snackbarOpen: true,
                            snackbarSeverity: "success",
                            message: "Report created!"
                        });
                    });
                }}>
                    <FormControl size="medium" key="report-formcontrol">
                        <TextField
                            key="report-name"
                            id="report-name"
                            type="text"
                            label="Title"
                            required={true}
                            defaultValue=""
                            variant="standard"
                            size="medium"
                            autoFocus={true}
                        />
                    </FormControl>
                    <br />
                    <br />
                    <Typography variant="h6" align="left" gutterBottom component="h6">
                        SSH Inspections:
                        <Tooltip title="Add" style={{ margin: "5px" }}>
                            <IconButton size="small" color="inherit" onClick={() => {
                                this.setState({
                                    ssh: this.state.ssh.concat([{
                                        "host": "",
                                        "port": "22",
                                        "username": "",
                                        "password": "",
                                        "private_key": "",
                                    }])
                                });
                            }}>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                    <FormGroup style ={{width: '600px'}}>
                        {sshElements}
                    </FormGroup>
                    <LoadingButton
                        type="submit"
                        loading={this.state.loadingNewTask}
                        loadingPosition="end"
                        endIcon={<ArrowForwardIcon />}
                        size="large"
                        variant="contained"
                    >
                        Submit
                    </LoadingButton>
                </form>
            </>
        )
    }
};
